/**
 * Copyright 2020, IntraLinks, Inc, All rights reserved.
 */

var NOTIFICATION_ICON_KIND = {
  error: 'status-error',
  info: 'status-info',
  success: 'status-success',
  warning: 'status-warning',
  loading: 'status-loading'
};

export { NOTIFICATION_ICON_KIND };
